import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { WordCloudSetting } from '../../../models/settings/word-cloud-setting';
import { SurveyQuestionModel } from '../../../models/survey/survey.model';
import { HttpRequestService } from '../../../shared/services/http-request.service';

@Injectable()
export class WordCloudSettingsService {

  private updateSettingUrl = environment.apiUrl + '/WordCloudSettings/SaveSetting';
  private getSettingUrl = environment.apiUrl + '/WordCloudSettings/GetSetting';
  private updateQuestionSettingUrl = environment.apiUrl + '/WordCloudSettings/SaveQuestionSetting';
  private getQuestionSettingUrl = environment.apiUrl + '/WordCloudSettings/GetQuestionSetting';
  constructor(private http: HttpRequestService, private httpClient: HttpClient) { }
  updateGlobalCloudSetting(data: WordCloudSetting) {
    return this.http.post(this.updateSettingUrl, data, false);
  }

  getGlobalCloudSetting() {
    return this.http.get(this.getSettingUrl , false);
  }
  getQuestionCloudSetting(questionId: number){
    return this.http.get(this.getQuestionSettingUrl +'?questionId='+ questionId, false);
  }

  updateQuestionCloudSetting(settingExceptionWord: SurveyQuestionModel) {
    return this.http.post(this.updateQuestionSettingUrl, settingExceptionWord, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/settings/word-cloud-settings/word-cloud-settings.service.ts